<template>
    <div class="upcoming-events-page">
        <bread-crumbs/>
        <content-subheader-page class="upcoming-events-page-content-subheader" text="МЕРОПРИЯТИЯ"/>
        <div class="upcoming-events-page-container">
            <div class="upcoming-events-page-toolbar">
                <upcoming-events-content-buttons
                    @squaresClick="squaresClick()"
                    @rectangleClick="rectangleClick()"
                />
                <div class="upcoming-events-page-week-slider">
                    <upcoming-events-week-slider/>
                </div>
                <div class="upcoming-events-page-vcalendar-container">
                    <div class="upcoming_events_page_vcalendar">
                        <v-calendar
                            :selectedDate="selectedDate"
                            @dayClick="dayClick"
                            :events = "vCalendarEvents"
                            parentClass="upcoming_events_page_vcalendar"/>
                    </div>
                </div>
                <div class="upcoming-events-page-filter">
                    <events-filter/>
                </div>
            </div>
            <div
                v-if="showCalendar" 
                class="upcoming-events-page-event-calendar">
                <upcoming-events-full-calendar
                    :move="move"
                    @endMove="changeMove('')"
                    @changeWeekDate="changeWeekDate()"
                />
            </div>
            <div v-else
                class="upcoming-events-page-events-cards">
                <upcoming-events-cards/>
            </div>
        </div>
    </div>
</template>
<script>

import ContentSubheaderPage from '@/components/content/ContentSubheaderPage.vue'
import BreadCrumbs from '@/components/breadcrumbs/BreadCrumbs.vue'
import VCalendar from '@/components/v-calendar/VCalendar.vue'
import EventsFilter from '@/components/eventsFilter/EventsFilter.vue'
import UpcomingEventsWeekSlider from '@/components/weekSlider/UpcomingEventsWeekSlider'
import UpcomingEventsFullCalendar from '@/components/fullCalendar/UpcomingEventsFullCalendar.vue'
import UpcomingEventsContentButtons from '@/components/contentButtons/UpcomingEventsContentButtons.vue'
import UpcomingEventsCards from '@/components/upcomingEventsCards/UpcomingEventsCards.vue'
import { useEventsStore } from '@/store/events'
export default {
    name: 'UpcomingEventsPage',
    components: {
        BreadCrumbs,
        VCalendar,
        ContentSubheaderPage,
        UpcomingEventsFullCalendar,
        UpcomingEventsWeekSlider,
        UpcomingEventsContentButtons,
        EventsFilter,
        UpcomingEventsCards
    },
    data(){        
        let events = []
        return {
            'showCalendar': false,
            'events': events,
            'move':'',
        }
    },
    computed:{
        selectedDateComp(){
            const eventsStore = useEventsStore()
            return eventsStore.selectedDate
        },
        selectedDate(){
            const eventsStore = useEventsStore()
            return eventsStore.selectedDate
        },
        vCalendarEvents(){
            const eventsStore = useEventsStore()
            let return_events = []
            for (let event of eventsStore.eventsFilters){
                let color = eventsStore.getEventColor(event)
                if (color == "#0635AC")
                    color = "blue"
                if (color == "#00AA8A")
                    color = "green"
                if (color == "#F24956")
                    color = "red"
                if (color == "#AA0075")
                    color = "red"
                let text = event.description
                let eventName = event.summary
                if (text === null)
                    text = ''
                if (eventName === null)
                    eventName = ''
                return_events.push({
                    'date': event.date_start,
                    'date_end': event.date_end,
                    'text': text,
                    'eventName': text,
                    'color': color
                })
            }
            return return_events
        }
    },
    methods:{
        changeMove(newMove){
            this.move = newMove
        },
        changeWeekDate(){
            
        },
        dayClick(day){
            const eventsStore = useEventsStore()
            eventsStore.setSelectedDate(day)
            eventsStore.setDateIsSelected(true)
        },
        squaresClick(){
            this.showCalendar = true
        },
        rectangleClick(){
            this.showCalendar = false
        }
    },
    async mounted(){
        const eventsStore = useEventsStore()
        await eventsStore.getAllEvents()
        // if (!eventsStore.dateIsSelected)
        eventsStore.setDateToThisMonth()
    }
}
</script>